import { useEffect, useState } from "react";
import RatingItem from "../../GlobalClassification/RatingItem";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import Icontrash from "../../../../layout/others/icon_delete.svg";
import { CommonService } from "../../../../services/CommonService";

export default function PersonalSkillsAndCompetences() {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
  const [personalSkills, setpersonalSkills] = useState([]);

  function onChangeSkillRanting(rating, id) {
    let _hardSkills = [...searchObject.personalSkills];
    let index = _hardSkills.map((skill) => skill.id).indexOf(id);
    if (index > -1) _hardSkills[index].rating = rating;
    setSearchObject({
      ...searchObject,
      personalSkills: _hardSkills
    });
  }

  useEffect(
    () => CommonService.getAllSkills().then((data) => setpersonalSkills(data)),
    []
  );
  
  useEffect(() => {
    initiatePersonalSkills();
  }, [personalSkills]);

  function initiatePersonalSkills() {
    if (
      !searchObject.personalSkills ||
      searchObject.personalSkills.length === 0
    )
      if (personalSkills && personalSkills.length > 0) {
        let _personnalSkills = personalSkills.map((skill) => {
          return {
            description: skill.description,
            id: skill.id,
            rating: 0
          };
        });
        setSearchObject({
          ...searchObject,
          personalSkills: _personnalSkills
        });
      }
  }

  function clearRating() {
    if (personalSkills && personalSkills.length > 0) {
      let _personnalSkills = personalSkills.map((skill) => {
        return {
          description: skill.description,
          id: skill.id,
          rating: 0
        };
      });
      setSearchObject({
        ...searchObject,
        personalSkills: _personnalSkills
      });
    }
  }

  return (
    <fieldset>
      <legend>{t("Personal Skills and Competences")}</legend>
      <div className="row">
        <div className="col-9">
          {searchObject.personalSkills &&
            searchObject.personalSkills.map((skill) => (
              <div className="row" key={skill.id}>
                <div className="col">{t(skill.description)}</div>
                <div className="col">
                  <RatingItem skill={skill} onChange={onChangeSkillRanting} />
                </div>
              </div>
            ))}
        </div>
        <div className="col text-end">
          <button
            style={{ position: "relative", float: "right" }}
            onClick={clearRating}
            className="app-button btn-second btn-md"
          >
            <img src={Icontrash} alt="ico-ppl" height="12px" width="auto" />{" "}
          </button>
        </div>
      </div>
    </fieldset>
  );
}
